import { useMemo } from "react";
import useAxios from "./useAxios";
import AppConfig from "../AppConfig";

// useAxios preconfigured for the PFQ service with a stable, memoized config
const usePfqAxios = ({ timeout } = {}) => {
    const config = useMemo(
        () => ({ baseURL: AppConfig.PfqBaseUrl, ...(timeout && { timeout }) }),
        [timeout]
    );
    return useAxios(config);
};

export default usePfqAxios;
